// extracted by css-extract-rspack-plugin
export default {"search":"R1UOO","options":"arYrd","option":"rcJAa","noResultsIcon":"neU4t","sampleDbIndicator":"qhTaj"};